import { FC, memo } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import operationTypes from 'constants/operationTypes';

type TransactionDetailsOperationTableHeaderProps = {
  operationType: string;
};

const TransactionDetailsOperationTableHeader: FC<
  TransactionDetailsOperationTableHeaderProps
> = ({ operationType }) => {
  const { t } = useTranslate();

  const renderCondition =
    operationType === operationTypes.SELL_PARTICIPATION ||
    operationType === operationTypes.HERITAGE ||
    operationType === operationTypes.DONATION;

  const showShares = operationType !== operationTypes.CONTRIBUTION;
  const showNominalValue = operationType !== operationTypes.CONTRIBUTION;
  const showPremium = operationType !== operationTypes.CONTRIBUTION;

  return (
    <>
      <thead>
        <tr>
          <th className="text-left">{t('Partner')}</th>
          <th className="text-left">{t('Description')}</th>
          {showShares && <th className="text-left">{t('NrPart.')}</th>}
          {showNominalValue && (
            <th className="text-left">{t('NominalValue')}</th>
          )}
          {renderCondition ? (
            <th className="text-left">{t('PricePart.')}</th>
          ) : (
            showPremium && <th className="text-left">{t('Premium')}</th>
          )}
          {operationType === operationTypes.CAPITAL_INCREASE && (
            <>
              <th className="text-left">{t('TotalVNominal')}</th>
              <th className="text-left">{t('TotalPremium')}</th>
            </>
          )}
          {operationType === operationTypes.DIVIDENDS_DISTRIBUTION ? (
            <th className="text-left">{t('DividendsTotal')}</th>
          ) : (
            <th className="text-right">{t('TotalInvestment')}</th>
          )}
          <th className="text-right">{t('%')}</th>
        </tr>
      </thead>
    </>
  );
};

export default memo(TransactionDetailsOperationTableHeader);
